import { currenciesList } from '@src/constants/settings/index'
import { DOMAIN_TITLE } from '@src/constants/general-constants'
import defaultLogo from '@src/assets/images/logo.svg'
export default {
  selectedCampusId(state) {
    return state.currentCampusScope?.id || null
  },

  userRole(state) {
    return state.activeRole || null
  },

  allowedCurrencies(state) {
    let currencies = []
    currenciesList.forEach((currenncy) => {
      if (state.generalSettings.allowed_currencies.includes(currenncy.id)) {
        currencies.push(currenncy)
      }
    })
    return currencies
  },
  defaultCurrency(state) {
    return state.generalSettings.default_currency
  },
  campusTimeZone(state) {
    return state?.generalSettings?.default_timezone || ''
  },
  isMultipleCampusesAllowed(state) {
    return state?.systemSettings?.multiple_campuses_allowed || false
  },
  isManualPasswordResetAllowed(state) {
    return state.systemSettings.manual_password_reset_allowed || null
  },
  instituteLogo(state) {
    return state.systemSettings.image || defaultLogo
  },
  instituteTitle(state) {
    return state?.systemSettings?.title || DOMAIN_TITLE
  },
  disabledFeature: (state) => state.disabledFeature,
}
